import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from './Context'
import { BlogContainer } from '@ztechapps/blog.webui'
import { PostEmptyContent } from '../../../components/PostEmptyContent'
import { DataSuspense } from '@ztechapps/webui.util'
import { useParams } from 'react-router-dom'
import { useConversationWidgetContext } from '../../../components/ConversationWidget'
import { PageTitle } from '../../../components/PageTitle'

export const Layout = () => {
  const { document, error, loading } = useContext()
  const { openConversationWidget } = useConversationWidgetContext()

  const { _id } = useParams()

  React.useEffect(() => {
    if (_id === 'contact-us') {
      openConversationWidget()
    }
  }, [_id, openConversationWidget])

  return (
    <DataSuspense error={error} loading={loading} isEmpty={isEmpty(document)} emptyComponent={<PostEmptyContent />}>
      {!isEmpty(document) && (
        <PageTitle
          title={document.title}
          description={document.summary || `Read more about ${document.title} on PanelPunches.`}
        />
      )}
      <BlogContainer blog={document} />
    </DataSuspense>
  )
}
